import Layout from "./components/layout/layout";
import ScrollToTop from "./utils/ScrollToTop";
import { Route, Routes } from "react-router-dom";

import UnauthenticatedOnly from "./protected-routes/UnauthenticatedOnly";
import AuthenticatedOnly from "./protected-routes/AuthenticatedOnly";

import { Helmet } from "react-helmet";
import SubscripersOnly from "./protected-routes/SubscripersOnly";
import { Suspense, lazy } from "react";
import { CircularProgress, Stack, useTheme } from "@mui/material";

import PropagateLoader from 'react-spinners/PropagateLoader'

const Home = lazy(() => import("./pages/home/index"));
const Halls = lazy(() => import("./pages/halls"));
const Photographers = lazy(() => import("./pages/photographers"));
const Monshed = lazy(() => import("./pages/monshed"));
const Singers = lazy(() => import("./pages/singers"));
const Djs = lazy(() => import("./pages/djs"));
const Organizers = lazy(() => import("./pages/organizers"));
const Isterahas = lazy(() => import("./pages/isterahas"));
const About = lazy(() => import("./pages/about"));
const Contact = lazy(() => import("./pages/contact"));
const Login = lazy(() => import("./pages/login"));
const Register = lazy(() => import("./pages/register"));
const HallDetails = lazy(() => import("./pages/hall-details"));
const PhotographerDetails = lazy(() => import("./pages/photographer-details"));
const MonshedDetails = lazy(() => import("./pages/monshed-details"));
const SingerDetails = lazy(() => import("./pages/singer-details"));
const DjDetails = lazy(() => import("./pages/dj-details"));
const OrganizerDetails = lazy(() => import("./pages/organizer-details"));
const IsterahaDetails = lazy(() => import("./pages/isteraha-details"));
const DBMain = lazy(() => import("./pages/dashboard-halls/HallDashboard"));
const PhotographerDB = lazy(() => import("./pages/dashboard-photographers/PhotographerDashboard"));
const SingerDB = lazy(() => import("./pages/dashboard-singers/SingerDashboard"));
const MonshedDB = lazy(() => import("./pages/dashboard-monshed/MonshedDashboard"));
const DjDB = lazy(() => import("./pages/dashboard-djs/DjDashboard"));
const OrganizerDB = lazy(() => import("./pages/dashboard-organizers/OrganizerDashboard"));
const DBIMain = lazy(() => import("./pages/dashboard-isterahat/DBIMain"));
const User = lazy(() => import("./pages/user/User"));
const NotFoundPage = lazy(() => import("./pages/notFound/notFoundPage"));
const Recovery = lazy(() => import("./pages/login/RecRest/indexRecover"));
const Reset = lazy(() => import("./pages/login/RecRest/inedexReset"));
const HallDashboard = lazy(() => import("./pages/dashboard/dashboard"));
const Resend = lazy(() => import("./pages/login/RecRest/Resend"));



const LoadingState = () => {
  const theme = useTheme()
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height="80vh"
      width="90vw"
    >
      <PropagateLoader size={30} color={theme.palette.primary.main} />
    </Stack>
  );
};
function App() {
  return (
    <Layout>
      <Helmet>
        <title>مناسبات</title>
        <link rel="icon" type="image/png" href="favicon.ico" sizes="16x16" />
      </Helmet>
      <ScrollToTop>
        <Routes>
          <Route
            path="/"
            element={
              <Suspense fallback={<LoadingState />}>
                <Home />
              </Suspense>
            }
          />
          <Route
            path="/about"
            element={
              <Suspense fallback={<LoadingState />}>
                <About />
              </Suspense>
            }
          />
          <Route
            path="/contact"
            element={
              <Suspense fallback={<LoadingState />}>
                <Contact />
              </Suspense>
            }
          />
          <Route element={<UnauthenticatedOnly />}>
            <Route
              path="/login"
              element={
                <Suspense fallback={<LoadingState />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/resend"
              element={
                <Suspense fallback={<LoadingState />}>
                  <Resend />
                </Suspense>
              }
            />
            <Route
              path="/register"
              element={
                <Suspense fallback={<LoadingState />}>
                  <Register />
                </Suspense>
              }
            />
            <Route
              path="/password/reset/"
              element={
                <Suspense fallback={<LoadingState />}>
                  <Recovery />
                </Suspense>
              }
            />
            <Route
              path="/password/reset/confirm/:uid/:token"
              element={
                <Suspense fallback={<LoadingState />}>
                  <Reset />
                </Suspense>
              }
            />
          </Route>
          <Route element={<AuthenticatedOnly />}>
            <Route
              path="/profile"
              element={
                <Suspense fallback={<LoadingState />}>
                  <User />
                </Suspense>
              }
            />
          </Route>
          <Route path="/halls">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Halls />
                </Suspense>
              }
            />
            <Route
              path="/halls/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <HallDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/photographers">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Photographers />
                </Suspense>
              }
            />
            <Route
              path="/photographers/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <PhotographerDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/singers">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Singers />
                </Suspense>
              }
            />
            <Route
              path="/singers/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <SingerDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/monshed">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Monshed />
                </Suspense>
              }
            />
            <Route
              path="/monshed/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <MonshedDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/djs">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Djs />
                </Suspense>
              }
            />
            <Route
              path="/djs/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <DjDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/organizers">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Organizers />
                </Suspense>
              }
            />
            <Route
              path="/organizers/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <OrganizerDetails />
                </Suspense>
              }
            />
          </Route>
          <Route path="/isterahat">
            <Route
              index
              element={
                <Suspense fallback={<LoadingState />}>
                  <Isterahas />
                </Suspense>
              }
            />
            <Route
              path="/isterahat/:id"
              element={
                <Suspense fallback={<LoadingState />}>
                  <IsterahaDetails />
                </Suspense>
              }
            />
          </Route>
          <Route element={<SubscripersOnly />}>
            <Route path="/dashboard">
              <Route
                path="/dashboard/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <HallDashboard />
                  </Suspense>
                }
              />
              <Route
                path="/dashboard/halls/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <DBMain />
                  </Suspense>
                }
              />
              <Route
                path="/dashboard/photographers/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <PhotographerDB />
                  </Suspense>
                }
              />              
              <Route
                path="/dashboard/singers/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <SingerDB />
                  </Suspense>
                }
              />
              <Route
                path="/dashboard/monshed/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <MonshedDB />
                  </Suspense>
                }
              />
              <Route
                path="/dashboard/djs/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <DjDB />
                  </Suspense>
                }
              />
              <Route
                path="/dashboard/organizers/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <OrganizerDB />
                  </Suspense>
                }
              /> 
              <Route
                path="/dashboard/isterahat/:id"
                element={
                  <Suspense fallback={<LoadingState />}>
                    <DBIMain />
                  </Suspense>
                }
              />
            </Route>
          </Route>
          <Route
            path="*"
            element={
              <Suspense fallback={<LoadingState />}>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Routes>
      </ScrollToTop>
    </Layout>
  );
}

export default App;
